// var rafId = null;
// var delay = 200;
// var lTime = 0;

// function scroll() {
//   var scrollTop = window.scrollY;
//   var height = window.innerHeight;
//   var visibleTop = scrollTop + height;

//   document.querySelectorAll('.reveal').forEach(function (el) {
//     if (el.classList.contains('reveal_visible')) {
//       return;
//     }

//     var top = el.getBoundingClientRect().top + scrollTop;

//     if (top <= visibleTop) {
//       if (top + el.offsetHeight < scrollTop) {
//         el.classList.remove('reveal_pending');
//         el.classList.add('reveal_visible');
//       } else {
//         el.classList.add('reveal_pending');

//         if (!rafId) {
//           requestAnimationFrame(reveal);
//         }
//       }
//     }
//   });
// }

// function reveal() {
//   rafId = null;

//   var now = performance.now();

//   if (now - lTime > delay) {
//     lTime = now;

//     var pending = document.querySelectorAll('.reveal_pending');

//     if (pending.length) {
//       pending[0].classList.remove('reveal_pending');
//       pending[0].classList.add('reveal_visible');
//     }
//   }

//   if (document.querySelectorAll('.reveal_pending').length >= 1) {
//     rafId = requestAnimationFrame(reveal);
//   }
// }

// scroll();

// window.addEventListener('scroll', scroll);

// window.addEventListener('click', function () {
//   document.querySelectorAll('.reveal').forEach(function (el) {
//     el.classList.remove('reveal_visible');
//     el.classList.remove('reveal_pending');
//   });

//   lTime = performance.now() + 500;

//   var top = window.scrollY;
//   window.scrollTo(0, top === 0 ? 1 : top - 1);
// });






(() => {
  if (window.themeSettings && window.themeSettings.enableSectionReveal === false) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const DELAY = 100;
  let rafId = null;
  let lastTime = 0;
  let io = null;

  const revealNext = (time) => {
    rafId = null;

    if (time - lastTime > DELAY) {
      lastTime = time;
      const pending = document.querySelector('.reveal_pending');
      if (pending) {
        pending.classList.remove('reveal_pending');
        pending.classList.add('reveal_visible');
      }
    }

    if (document.querySelector('.reveal_pending')) {
      rafId = requestAnimationFrame(revealNext);
    }
  };

  const queue = (el) => {
    if (
      !el ||
      el.classList.contains('reveal_visible') ||
      el.classList.contains('reveal_pending')
    ) {
      return;
    }

    el.classList.add('reveal_pending');
    if (!rafId) rafId = requestAnimationFrame(revealNext);
  };

  const observe = (root) => {
    if (!io) return;
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.reveal').forEach((el) => {
      if (el.classList.contains('reveal_visible')) return;
      io.observe(el);
    });
  };

  const init = () => {
    io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          queue(entry.target);
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    observe();

    document.querySelectorAll('.swiper-wrapper').forEach((wrap) => {
      if (wrap.classList.contains('swiper-loaded')) return;
      const mo = new MutationObserver(() => {
        if (!wrap.classList.contains('swiper-loaded')) return;
        mo.disconnect();
        requestAnimationFrame(() => observe(wrap.closest('bz-slider') || wrap.parentElement));
      });
      mo.observe(wrap, { attributes: true, attributeFilter: ['class'] });
    });

    document.addEventListener('shopify:section:load', (e) => {
      requestAnimationFrame(() => observe(e.target));
    });

    document.addEventListener('facetFilters:updated', () => {
      requestAnimationFrame(() => {
        observe(document.querySelector('.collection-products') || document);
      });
    });

    window.addEventListener('bz:slider:ready', (e) => {
      requestAnimationFrame(() => observe(e.target || document));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
